export * from './ProductCardV2Tag';
